export const fontSize = [
    {
        screen: 1,
        size: 18,
        sizeFs: 24,
    },
    {
        screen: 4,
        size: 16,
        sizeFs: 22,
    },
    {
        screen: 9,
        size: 14,
        sizeFs: 20,
    },
    {
        screen: 16,
        size: 12,
        sizeFs: 18,
    },
    {
        screen: 25,
        size: 11,
        sizeFs: 16,
    },
    {
        screen: 36,
        size: 11,
        sizeFs: 16,
    },
    {
        screen: 49,
        size: 10,
        sizeFs: 14,
    },
    {
        screen: 64,
        size: 10,
        sizeFs: 14,
    },

]

export const sizeImage = [
    {
        screen: 1,
        size: 100,
        sizeFs: 100,
    },
    {
        screen: 4,
        size: 60,
        sizeFs: 80,
    },
    {
        screen: 9,
        size: 46,
        sizeFs: 72,
    },
    {
        screen: 16,
        size: 36,
        sizeFs: 72,
    },
    {
        screen: 25,
        size: 28,
        sizeFs: 72,
    },
    {
        screen: 36,
        size: 20,
        sizeFs: 64,
    },
    {
        screen: 49,
        size: 20,
        sizeFs: 64,
    },
    {
        screen: 64,
        size: 20,
        sizeFs: 64,
    },

]